// Bestcotti marketing sections for Dawn — accordions, visual tabs, postal-code checker.
(function () {
  var nodes = function (root, selector) {
    var matches = [];
    if (root && root.nodeType === 1 && root.matches(selector)) matches.push(root);
    if (root && root.querySelectorAll) {
      root.querySelectorAll(selector).forEach(function (node) { matches.push(node); });
    }
    return matches;
  };

  var motionOK = function () {
    return window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
  };

  var rootUrl = function () {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  };

  var formatMoney = function (cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
        style: 'currency',
        currency: currency
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  };

  var setCartCount = function (count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = count;
    });
    document.querySelectorAll('.bc .cart-pill').forEach(function (pill) {
      pill.classList.toggle('is-empty', Number(count) === 0);
      pill.setAttribute('aria-label', 'Cart with ' + count + ' items');
    });
  };

  // ----- Scroll reveals -----
  var REVEAL_SELECTORS = [
    '.bc .section-head', '.bc .hero-text', '.bc .hero-visual', '.bc .product-card',
    '.bc .cat-card', '.bc .basket-card', '.bc .testimonial', '.bc .value', '.bc .step',
    '.bc .audience-card', '.bc .tier-card', '.bc .local-card', '.bc .schedule-card',
    '.bc .tl-item', '.bc .story-snippet .container > div', '.bc .contact-note-card',
    '.bc .contact-path-card', '.bc .contact-info-card'
  ].join(', ');

  var revealObserver = null;
  var initReveal = function (root) {
    if (!('IntersectionObserver' in window) || !motionOK()) return;
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          revealObserver.unobserve(el);
          var delay = parseInt(el.style.getPropertyValue('--bc-reveal-delay'), 10) || 0;
          el.classList.add('bc-inview');
          // Hand styling back to the stylesheet once the entrance is done,
          // so reveal transitions never fight hover transitions.
          window.setTimeout(function () {
            el.classList.remove('bc-reveal', 'bc-inview');
            el.style.removeProperty('--bc-reveal-delay');
          }, 900 + delay);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    }

    var staggerIndex = [];
    nodes(root, REVEAL_SELECTORS).forEach(function (el) {
      if (el.dataset.bcRevealInitialized === 'true') return;
      el.dataset.bcRevealInitialized = 'true';
      var group = null;
      for (var i = 0; i < staggerIndex.length; i++) {
        if (staggerIndex[i].parent === el.parentNode) { group = staggerIndex[i]; break; }
      }
      if (!group) { group = { parent: el.parentNode, count: 0 }; staggerIndex.push(group); }
      var delay = Math.min(group.count * 70, 420);
      group.count += 1;
      if (delay) el.style.setProperty('--bc-reveal-delay', delay + 'ms');
      el.classList.add('bc-reveal');
      revealObserver.observe(el);
    });
  };

  // ----- Fly-to-cart -----
  var flyToCart = function (fromEl, toEl) {
    if (!fromEl || !toEl || !motionOK()) return;
    var a = fromEl.getBoundingClientRect();
    var b = toEl.getBoundingClientRect();
    var el = document.createElement('div');
    el.className = 'bc-fly-cookie';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M24 6.5c9.5 0 17.5 7.6 17.5 17.2 0 9.8-7.7 17.8-17.4 17.8C14.3 41.5 6.5 33.7 6.5 24 6.5 14.3 14.4 6.5 24 6.5Z"/><circle cx="17" cy="19.5" r="1.6" fill="currentColor"/><circle cx="30" cy="16" r="1.6" fill="currentColor"/><circle cx="23.5" cy="28" r="1.6" fill="currentColor"/><circle cx="32.5" cy="31.5" r="1.6" fill="currentColor"/><circle cx="14.5" cy="31.5" r="1.6" fill="currentColor"/></svg>';
    el.style.left = (a.left + a.width / 2 - 17) + 'px';
    el.style.top = (a.top + a.height / 2 - 17) + 'px';
    document.body.appendChild(el);
    void el.offsetWidth;
    el.style.transform = 'translate(' + (b.left + b.width / 2 - (a.left + a.width / 2)) + 'px, '
      + (b.top + b.height / 2 - (a.top + a.height / 2)) + 'px) scale(0.25) rotate(150deg)';
    el.style.opacity = '0.25';
    window.setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 780);
  };

  // ----- Cart drawer -----
  // Renders live cart state from /cart.js: line items with quantity
  // controls, a free-delivery progress meter, an order note and an
  // optional upsell. Falls back to the /cart page whenever fetch,
  // the drawer markup, or a request is unavailable.
  var cartDrawer = null;

  var initCartDrawer = function (root) {
    var drawer = nodes(root, '[data-bc-cart-drawer]')[0];
    if (!drawer || drawer.dataset.bcDrawerInitialized === 'true' || !window.fetch) return;
    drawer.dataset.bcDrawerInitialized = 'true';

    // Re-home the drawer on its own .bc host so it can never inherit a
    // clipping or stacking context from the sticky header section.
    // Theme-editor section reloads ship a fresh drawer, so drop the old host.
    document.querySelectorAll('.bc-cart-drawer-host').forEach(function (stale) {
      if (stale.parentNode) stale.parentNode.removeChild(stale);
    });
    var host = document.createElement('div');
    host.className = 'bc bc-cart-drawer-host';
    document.body.appendChild(host);
    host.appendChild(drawer);

    var panel = drawer.querySelector('.cart-drawer-panel');
    var linesList = drawer.querySelector('[data-cart-lines]');
    var emptyState = drawer.querySelector('[data-cart-empty]');
    var loading = drawer.querySelector('[data-cart-loading]');
    var foot = drawer.querySelector('[data-cart-foot]');
    var subtotal = drawer.querySelector('[data-cart-subtotal]');
    var meter = drawer.querySelector('[data-cart-meter]');
    var meterText = drawer.querySelector('[data-cart-meter-text]');
    var meterFill = drawer.querySelector('[data-cart-meter-fill]');
    var upsell = drawer.querySelector('[data-cart-upsell]');
    var noteBox = drawer.querySelector('[data-cart-note]');
    var noteInput = drawer.querySelector('[data-cart-note-input]');
    var noteStatus = drawer.querySelector('[data-cart-note-status]');
    var closeButton = drawer.querySelector('.cart-drawer-close');

    var threshold = parseInt(drawer.dataset.threshold, 10) || 0;
    var lastFocused = null;
    var noteTimer = null;
    var busy = false;

    var setBusy = function (state) {
      busy = state;
      drawer.classList.toggle('is-busy', state);
    };

    var renderMeter = function (total) {
      if (!meter || threshold <= 0) return;
      meter.hidden = false;
      var remaining = threshold - total;
      var pct = Math.max(0, Math.min(100, (total / threshold) * 100));
      if (meterFill) meterFill.style.width = pct + '%';
      meter.classList.toggle('is-complete', remaining <= 0);
      if (!meterText) return;
      meterText.textContent = remaining > 0
        ? formatMoney(remaining) + ' ' + (drawer.dataset.thresholdPending || '')
        : (drawer.dataset.thresholdMet || '');
    };

    var buildLine = function (item, index) {
      var li = document.createElement('li');
      li.className = 'cart-line';
      li.dataset.lineKey = item.key;

      var media = document.createElement('a');
      media.className = 'cart-line-media';
      media.href = item.url || '#';
      var imageUrl = (item.featured_image && item.featured_image.url) || item.image;
      if (imageUrl) {
        var img = document.createElement('img');
        img.src = imageUrl.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2');
        img.alt = (item.featured_image && item.featured_image.alt) || '';
        img.loading = 'lazy';
        media.appendChild(img);
      }

      var body = document.createElement('div');
      body.className = 'cart-line-body';

      var title = document.createElement('a');
      title.className = 'cart-line-title';
      title.href = item.url || '#';
      title.textContent = item.product_title || item.title;
      body.appendChild(title);

      if (item.variant_title) {
        var variant = document.createElement('span');
        variant.className = 'cart-line-variant';
        variant.textContent = item.variant_title;
        body.appendChild(variant);
      }

      var controls = document.createElement('div');
      controls.className = 'cart-line-controls';

      var qty = document.createElement('div');
      qty.className = 'cart-line-qty';
      ['minus', 'plus'].forEach(function (kind) {
        var button = document.createElement('button');
        button.type = 'button';
        button.dataset.lineChange = kind;
        button.dataset.lineIndex = index + 1;
        button.dataset.lineQuantity = kind === 'minus' ? item.quantity - 1 : item.quantity + 1;
        button.setAttribute('aria-label', (kind === 'minus' ? 'Decrease' : 'Increase')
          + ' quantity of ' + (item.product_title || item.title));
        button.textContent = kind === 'minus' ? '−' : '+';
        if (kind === 'minus') {
          qty.appendChild(button);
          var value = document.createElement('span');
          value.textContent = item.quantity;
          qty.appendChild(value);
        } else {
          qty.appendChild(button);
        }
      });
      controls.appendChild(qty);

      var price = document.createElement('span');
      price.className = 'cart-line-price';
      price.textContent = formatMoney(item.final_line_price != null ? item.final_line_price : item.line_price);
      controls.appendChild(price);
      body.appendChild(controls);

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'cart-line-remove';
      remove.dataset.lineChange = 'remove';
      remove.dataset.lineIndex = index + 1;
      remove.dataset.lineQuantity = 0;
      remove.setAttribute('aria-label', 'Remove ' + (item.product_title || item.title) + ' from the basket');
      remove.textContent = 'Remove';
      body.appendChild(remove);

      li.appendChild(media);
      li.appendChild(body);
      return li;
    };

    var render = function (cart) {
      if (!cart) return;
      if (loading) loading.hidden = true;
      setCartCount(cart.item_count);

      if (linesList) {
        linesList.textContent = '';
        (cart.items || []).forEach(function (item, index) {
          linesList.appendChild(buildLine(item, index));
        });
      }

      var isEmpty = !cart.item_count;
      if (emptyState) emptyState.hidden = !isEmpty;
      if (foot) foot.hidden = isEmpty;
      if (linesList) linesList.hidden = isEmpty;
      if (meter) meter.hidden = isEmpty || threshold <= 0;
      if (noteBox) noteBox.hidden = isEmpty;

      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
      if (!isEmpty) renderMeter(cart.total_price);

      if (upsell) {
        var upsellId = parseInt(upsell.dataset.upsellProductId, 10);
        var alreadyIn = (cart.items || []).some(function (item) { return item.product_id === upsellId; });
        upsell.hidden = isEmpty || alreadyIn;
      }

      if (noteInput && document.activeElement !== noteInput) {
        noteInput.value = cart.note || '';
      }
    };

    var refresh = function () {
      return fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (cart) { render(cart); return cart; })
        .catch(function () {
          if (loading) loading.textContent = 'The basket could not load. Open the full basket page instead.';
          return null;
        });
    };

    var changeLine = function (line, quantity) {
      if (busy) return;
      setBusy(true);
      fetch(rootUrl() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (cart) {
          if (cart) render(cart);
          else window.location.href = rootUrl() + 'cart';
        })
        .catch(function () { window.location.href = rootUrl() + 'cart'; })
        .finally(function () { setBusy(false); });
    };

    var saveNote = function () {
      if (!noteInput) return;
      fetch(rootUrl() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: noteInput.value })
      })
        .then(function (response) {
          if (noteStatus) noteStatus.textContent = response.ok ? 'Note saved' : 'Note could not be saved';
        })
        .catch(function () {
          if (noteStatus) noteStatus.textContent = 'Note could not be saved';
        });
    };

    var open = function (trigger) {
      if (!drawer.hidden) return;
      // Prefer the control that opened the drawer; document.activeElement is
      // often <body> when the drawer is opened from an add-to-cart response.
      lastFocused = trigger
        || (document.activeElement && document.activeElement !== document.body ? document.activeElement : null)
        || document.querySelector('[data-cart-drawer-open]');
      drawer.hidden = false;
      // Let the browser paint the hidden state before transitioning in.
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      document.documentElement.classList.add('bc-drawer-open');
      if (closeButton) closeButton.focus();
      refresh();
    };

    var close = function () {
      if (drawer.hidden) return;
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('bc-drawer-open');
      var finish = function () { drawer.hidden = true; };
      if (motionOK()) window.setTimeout(finish, 320);
      else finish();
      var returnTo = lastFocused && lastFocused.isConnected
        ? lastFocused
        : document.querySelector('[data-cart-drawer-open]');
      if (returnTo && returnTo.focus) returnTo.focus();
    };

    drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (node) {
      node.addEventListener('click', close);
    });

    drawer.addEventListener('click', function (event) {
      var control = event.target.closest('[data-line-change]');
      if (!control) return;
      event.preventDefault();
      changeLine(parseInt(control.dataset.lineIndex, 10), parseInt(control.dataset.lineQuantity, 10));
    });

    drawer.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab' || !panel) return;
      var focusable = panel.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, summary');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (noteInput) {
      noteInput.addEventListener('input', function () {
        if (noteStatus) noteStatus.textContent = '';
        window.clearTimeout(noteTimer);
        noteTimer = window.setTimeout(saveNote, 700);
      });
      noteInput.addEventListener('blur', function () {
        window.clearTimeout(noteTimer);
        saveNote();
      });
    }

    cartDrawer = { open: open, close: close, refresh: refresh };

    document.addEventListener('bc:cart:added', function () {
      refresh().then(function () { open(); });
    });
  };

  // ----- Product carousel -----
  // The strip already scrolls natively (touch, trackpad, keyboard on the
  // focused track). This only adds arrows for mouse users, and hides them
  // entirely when everything already fits — arrows that do nothing are
  // worse than none.
  var initCarousels = function (root) {
    nodes(root, '.bc [data-carousel-track]').forEach(function (track) {
      if (track.dataset.bcCarouselInitialized === 'true') return;
      track.dataset.bcCarouselInitialized = 'true';

      var scope = track.closest('[data-carousel]') || track.closest('section') || document;
      var nav = scope.querySelector('[data-carousel-nav]');
      var prev = scope.querySelector('[data-carousel-prev]');
      var next = scope.querySelector('[data-carousel-next]');
      if (!nav || !prev || !next) return;

      var step = function () {
        var item = track.querySelector('.carousel-item') || track.firstElementChild;
        if (!item) return Math.round(track.clientWidth * 0.8);
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return Math.round(item.getBoundingClientRect().width + gap);
      };

      var overflows = function () {
        return track.scrollWidth - track.clientWidth > 4;
      };

      var sync = function () {
        if (!overflows()) {
          nav.hidden = true;
          return;
        }
        nav.hidden = false;
        // scrollLeft goes negative in RTL, so compare on absolute distance.
        var left = Math.abs(track.scrollLeft);
        var max = track.scrollWidth - track.clientWidth;
        prev.disabled = left <= 2;
        next.disabled = left >= max - 2;
      };

      var scrollBy = function (direction) {
        track.scrollBy({
          left: step() * direction,
          behavior: motionOK() ? 'smooth' : 'auto'
        });
      };

      prev.addEventListener('click', function () { scrollBy(-1); });
      next.addEventListener('click', function () { scrollBy(1); });

      // sync() is three layout reads and two boolean writes, and the browser
      // already caps scroll events to the frame rate — so call it directly.
      // Coalescing behind requestAnimationFrame risks latching the buttons
      // permanently if a frame never arrives (background tab, hidden pane).
      track.addEventListener('scroll', sync, { passive: true });

      if ('ResizeObserver' in window) {
        new ResizeObserver(sync).observe(track);
      } else {
        window.addEventListener('resize', sync);
      }
      // Cards are lazy-loaded, so scrollWidth is not final on first paint.
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync).catch(sync);
      sync();
    });
  };

  var initCartDrawerTriggers = function (root) {
    nodes(root, '[data-cart-drawer-open]').forEach(function (trigger) {
      if (trigger.dataset.bcDrawerTrigger === 'true') return;
      trigger.dataset.bcDrawerTrigger = 'true';
      trigger.addEventListener('click', function (event) {
        if (!cartDrawer) return;
        event.preventDefault();
        cartDrawer.open(trigger);
      });
    });
  };

  // ----- Delivery zone highlighting -----
  // The schematic map and the zone list are two views of the same data,
  // so both the postal checker and pointer hover drive them together.
  var eachZoneNode = function (zoneId, callback) {
    if (!zoneId) return;
    document.querySelectorAll('[data-zone-id="' + zoneId + '"]').forEach(callback);
  };

  var setActiveZone = function (zoneId) {
    document.querySelectorAll('[data-zone-id]').forEach(function (node) {
      node.classList.remove('is-active');
    });
    eachZoneNode(zoneId, function (node) { node.classList.add('is-active'); });
  };

  var hoverZone = function (zoneId, on) {
    eachZoneNode(zoneId, function (node) { node.classList.toggle('is-hover', !!on); });
  };
  // ----- Homepage splash: the masthead opens as a full screen -----
  // The header is the splash. It starts a viewport tall with the wordmark
  // large and the real navigation spread beneath it, and scrolling contracts
  // the same elements into the ordinary bar. Nothing is duplicated and nothing
  // crossfades, so there is no handoff that can land in the wrong place.
  //
  // Three things this has to get right.
  //
  // The header is fixed, not sticky. A sticky header that shrinks pulls the
  // document up behind it, the browser renumbers scrollY to compensate, and
  // that number is what drives the contraction — a loop that oscillates. Fixed
  // takes it out of flow, and an empty spacer holds the scroll room open.
  //
  // Every landing value is measured with the splash styles off, so the resting
  // state the header contracts into is its real one, whatever the announcement
  // bar, the breakpoint or the theme editor chrome are doing.
  //
  // There is no colour change. The masthead wears the splash colour and keeps
  // it, so the field and the bar are one surface that never has to hand over
  // to another — which is why this function only ever writes a size.
  var WORDMARK_RATIO = 3.2984;
  // How much of the screen the wordmark takes on the splash. Also capped by
  // the width it would need, so height is always the binding dimension and the
  // contraction starts the moment the page moves.
  var SPLASH_MARK_VH = 0.26;
  var DEFAULT_SPLASH_SPEED = 8;

  var initSplash = function (root) {
    var docEl = document.documentElement;
    // The field and the masthead are two different sections, and the theme
    // editor reloads them one at a time. Whichever one comes back, look the
    // other up across the whole document — scoping to the reloaded subtree
    // finds only half the pair and leaves the survivor without a driver.
    var spacer = nodes(root, '[data-bc-splash-spacer]')[0]
      || document.querySelector('[data-bc-splash-spacer]');
    var shell = document.querySelector('[data-bc-header-root]');
    if (!spacer || !shell) return;
    // Keyed on the masthead, because that is the element carrying the state a
    // stale closure would be holding on to.
    if (shell.dataset.bcSplashInitialized === 'true' && spacer.dataset.bcSplashInitialized === 'true') return;
    // Shopify replaces either section independently in the customizer. Retire
    // the previous driver before reading the new section settings so changing
    // a slider updates the live preview without stacking scroll listeners.
    if (typeof docEl._bcSplashCleanup === 'function') {
      docEl._bcSplashCleanup();
    }
    shell.dataset.bcSplashInitialized = 'true';
    spacer.dataset.bcSplashInitialized = 'true';

    var brand = shell.querySelector('[data-bc-logo-target]');
    var mark = brand && brand.querySelector('.bc-wordmark');
    var siteHeader = shell.querySelector('.site-header');
    var container = siteHeader && siteHeader.querySelector('.container');
    var nav = shell.querySelector('.primary-nav');
    var tools = shell.querySelector('.header-tools');
    var announcement = shell.querySelector('.announcement');

    // No splash: the masthead is the plain bar it is on every other page and
    // the spacer collapses. Also the resting state for narrow screens and for
    // anyone who has asked for less motion.
    var goStatic = function () {
      if (frame) window.cancelAnimationFrame(frame);
      frame = null;
      renderedSp = null;
      lastFrameTime = null;
      geo = null;
      docEl.classList.remove('bc-splash');
      docEl.dataset.bcSplashRunning = 'true';
      if (shell) shell.classList.remove('is-opening');
      if (mark) mark.classList.remove('is-writing');
      ['--bc-sp', '--bc-mark-rest', '--bc-mark-big', '--bc-rest-h',
       '--bc-ann-h', '--bc-tools-dy'
      ].forEach(function (name) { docEl.style.removeProperty(name); });
    };

    if (!brand || !mark || !siteHeader || !container || !nav || !tools) {
      goStatic();
      return;
    }

    var narrow = window.matchMedia('(max-width: 600px)');
    var geo = null;
    var lastSp = null;
    var splashSpeed = parseFloat(spacer.getAttribute('data-bc-splash-speed'));
    if (!isFinite(splashSpeed)) splashSpeed = DEFAULT_SPLASH_SPEED;
    splashSpeed = Math.max(1, Math.min(10, splashSpeed));
    // A higher customizer value means a shorter catch-up window. The faster
    // default remains softly filtered, while 1–10 offers a useful full range.
    var splashSmoothingMs = 135 - (splashSpeed * 11);

    var clamp01 = function (value) {
      return value < 0 ? 0 : value > 1 ? 1 : value;
    };

    // Which element actually scrolls. Dawn scrolls the document; Horizon wraps
    // the page in its own overflow container (.page-wrapper) and scrolls that
    // instead. On such a theme window.pageYOffset is 0 for the life of the page
    // and a scroll event on the container never reaches window, because scroll
    // does not bubble — so a splash driven off the window freezes at full size
    // and covers the viewport with no way past it. Found by walking up from the
    // spacer rather than hard-coding a class, so it holds for any theme that
    // scrolls an element, whatever that element is called.
    var findScroller = function (el) {
      var node = el && el.parentNode;
      while (node && node.nodeType === 1 && node !== document.body && node !== docEl) {
        var overflowY = window.getComputedStyle(node).overflowY;
        if ((overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') &&
            node.scrollHeight > node.clientHeight + 1) return node;
        node = node.parentNode;
      }
      return null;
    };

    // null means the document is the scroller, which is the ordinary case.
    var scroller = null;
    var scrollBound = false;

    var scrollTop = function () {
      return scroller ? scroller.scrollTop : (window.pageYOffset || docEl.scrollTop);
    };

    // A fixed descendant is its own wheel/touch scroll chain in Chromium.
    // Horizon's real scroller is an ancestor (.page-wrapper), so gestures that
    // start on an interactive part of the fixed splash (the large wordmark,
    // navigation or tools) otherwise stop at the non-scrolling html/body. The
    // blank parts happen to work, which makes the page feel randomly locked.
    //
    // Forward gestures only when a nested element scroller was found. Dawn
    // scrolls the document and keeps its native behaviour. The scroller lives
    // on the shell so a Shopify theme-editor section reload can update it
    // without stacking another set of handlers on the surviving masthead.
    var bindSplashInput = function () {
      if (shell.dataset.bcSplashInputBound === 'true') return;
      shell.dataset.bcSplashInputBound = 'true';

      var touchY = null;
      var deltaPixels = function (event, targetScroller) {
        if (event.deltaMode === 1) return event.deltaY * 16;
        if (event.deltaMode === 2) return event.deltaY * targetScroller.clientHeight;
        return event.deltaY;
      };

      shell.addEventListener('wheel', function (event) {
        var targetScroller = shell._bcSplashScroller;
        if (!targetScroller || !docEl.classList.contains('bc-splash') ||
            event.ctrlKey || !event.deltaY) return;
        event.preventDefault();
        targetScroller.scrollTop += deltaPixels(event, targetScroller);
      }, { passive: false });

      shell.addEventListener('touchstart', function (event) {
        touchY = event.touches.length === 1 ? event.touches[0].clientY : null;
      }, { passive: true });

      shell.addEventListener('touchmove', function (event) {
        var targetScroller = shell._bcSplashScroller;
        if (!targetScroller || !docEl.classList.contains('bc-splash') ||
            touchY === null || event.touches.length !== 1) return;
        var nextY = event.touches[0].clientY;
        var deltaY = touchY - nextY;
        touchY = nextY;
        if (!deltaY) return;
        event.preventDefault();
        targetScroller.scrollTop += deltaY;
      }, { passive: false });

      var endTouch = function () { touchY = null; };
      shell.addEventListener('touchend', endTouch, { passive: true });
      shell.addEventListener('touchcancel', endTouch, { passive: true });
    };

    bindSplashInput();

    // Read the landing values with the splash styles off, so they are the
    // header's genuine resting geometry rather than a guess at it.
    var measure = function () {
      docEl.classList.add('bc-measuring');
      docEl.classList.remove('bc-splash');
      var restH = shell.getBoundingClientRect().height;
      var markRest = mark.getBoundingClientRect().height;
      var annH = announcement ? announcement.getBoundingClientRect().height : 0;
      docEl.classList.add('bc-splash');
      docEl.classList.remove('bc-measuring');

      if (!restH || !markRest) return null;

      // Cap the splash size by the width it would need, so height is the
      // binding dimension and the mark starts shrinking on the first pixel of
      // scroll. clientWidth, not innerWidth: the scrollbar is not usable space.
      var room = Math.min(container.getBoundingClientRect().width * 0.9, 1180);
      var markBig = Math.min(window.innerHeight * SPLASH_MARK_VH, room / WORDMARK_RATIO);
      markBig = Math.max(markBig, markRest);

      docEl.style.setProperty('--bc-mark-rest', markRest.toFixed(2) + 'px');
      docEl.style.setProperty('--bc-mark-big', markBig.toFixed(2) + 'px');
      docEl.style.setProperty('--bc-rest-h', restH.toFixed(2) + 'px');
      docEl.style.setProperty('--bc-ann-h', annH.toFixed(2) + 'px');

      // Where the tools sit when the wordmark is a screen high, and how far
      // that is from the corner they belong in while it is. Multiplied by the
      // progress, so at the landing the offset is exactly zero and they are
      // exactly where the grid puts them — nothing left to align.
      docEl.style.setProperty('--bc-sp', '1');
      docEl.style.setProperty('--bc-tools-dy', '0px');
      var toolsTop = tools.getBoundingClientRect().top;
      var toolsDy = (annH + 24) - toolsTop;

      // The contraction finishes as the page below the spacer reaches the
      // underside of the resting bar. The header and field use the same solid
      // colour, so the brief smoothing offset between their edges is invisible.
      var travel = Math.max(1, spacer.getBoundingClientRect().height - restH);

      return { restH: restH, travel: travel, toolsDy: toolsDy };
    };

    var frame = null;
    var renderedSp = null;
    var lastFrameTime = null;

    var writeProgress = function (sp) {
      // The masthead is one colour from the first frame to the last, so the
      // whole render is one custom-property write: no geometry reads and no
      // per-frame writes to the SVG.
      if (sp === lastSp) return;
      lastSp = sp;
      docEl.style.setProperty('--bc-sp', sp.toFixed(4));
    };

    var targetProgress = function () {
      return 1 - clamp01(scrollTop() / geo.travel);
    };

    var update = function (time) {
      frame = null;
      if (!geo) return;

      var targetSp = targetProgress();
      if (renderedSp === null || lastFrameTime === null) {
        renderedSp = targetSp;
      } else {
        // Exponential interpolation is refresh-rate independent: a 60 Hz and
        // a 144 Hz screen reach the same point after the same elapsed time.
        // Capping a resumed frame keeps a backgrounded tab from jumping.
        var elapsed = Math.min(48, Math.max(0, time - lastFrameTime));
        var blend = 1 - Math.exp(-elapsed / splashSmoothingMs);
        renderedSp += (targetSp - renderedSp) * blend;
      }
      lastFrameTime = time;

      if (Math.abs(targetSp - renderedSp) < 0.0005) {
        renderedSp = targetSp;
      }
      writeProgress(renderedSp);

      // Keep settling after the wheel/trackpad event ends. New input simply
      // moves the target, including an immediate reversal back toward splash.
      if (renderedSp !== targetSp) {
        frame = window.requestAnimationFrame(update);
      }
    };

    var schedule = function () {
      if (frame) return;
      // When input resumes after an idle spell, begin timing from the input
      // itself. Counting the idle time would make the first wheel step jump.
      lastFrameTime = window.performance && window.performance.now
        ? window.performance.now()
        : Date.now();
      frame = window.requestAnimationFrame(update);
    };

    var syncProgress = function () {
      if (frame) window.cancelAnimationFrame(frame);
      frame = null;
      renderedSp = targetProgress();
      lastFrameTime = null;
      writeProgress(renderedSp);
    };

    // Re-resolved on every setup, not just the first. At first paint the
    // container may not overflow yet — late images and web fonts are what push
    // it past a screen — and the load pass is what catches it once it does.
    var bindScroll = function () {
      var next = findScroller(spacer);
      if (scrollBound && next === scroller) return;
      if (scrollBound) (scroller || window).removeEventListener('scroll', schedule);
      scroller = next;
      shell._bcSplashScroller = scroller;
      (scroller || window).addEventListener('scroll', schedule, { passive: true });
      scrollBound = true;
    };

    var setup = function () {
      if (narrow.matches || !motionOK()) {
        goStatic();
        return;
      }
      docEl.classList.add('bc-splash');
      // Tells the inline block in bc-header.liquid that its safety net is no
      // longer needed: something is driving the contraction.
      docEl.dataset.bcSplashRunning = 'true';
      lastSp = null;
      geo = measure();
      if (!geo) {
        goStatic();
        return;
      }
      docEl.style.setProperty('--bc-tools-dy', geo.toolsDy.toFixed(2) + 'px');
      bindScroll();
      // Measurements, restored scroll positions and resizes should start at
      // the exact current position. Only live scrolling receives smoothing.
      syncProgress();
    };

    setup();

    // A restored scroll position should never replay the opening over the
    // middle of the page.
    var openingTimer = null;
    if (docEl.classList.contains('bc-splash') && scrollTop() < 4) {
      mark.classList.add('is-writing');
      shell.classList.add('is-opening');
      // Let the entrance finish before clearing the classes, or a re-render
      // mid-animation would restart it from nothing.
      openingTimer = window.setTimeout(function () {
        mark.classList.remove('is-writing');
        shell.classList.remove('is-opening');
      }, 2000);
    } else {
      mark.classList.remove('is-writing');
      shell.classList.remove('is-opening');
    }

    var resizeTimer = null;
    var onResize = function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(setup, 150);
    };
    window.addEventListener('resize', onResize, { passive: true });

    // Web fonts and late images shift the masthead, so take one more reading
    // once the page has settled.
    var loadTimer = null;
    var onLoad = function () {
      loadTimer = window.setTimeout(setup, 60);
    };
    window.addEventListener('load', onLoad);

    docEl._bcSplashCleanup = function () {
      if (frame) window.cancelAnimationFrame(frame);
      if (scrollBound) (scroller || window).removeEventListener('scroll', schedule);
      window.removeEventListener('resize', onResize);
      window.removeEventListener('load', onLoad);
      window.clearTimeout(openingTimer);
      window.clearTimeout(resizeTimer);
      window.clearTimeout(loadTimer);
      frame = null;
      scrollBound = false;
      docEl._bcSplashCleanup = null;
    };
  };

  // ----- Count-up numbers -----
  var initCountUp = function (root) {
    var targets = nodes(root, '[data-count-to]').filter(function (el) {
      return el.dataset.bcCountInitialized !== 'true';
    });
    if (!targets.length) return;

    targets.forEach(function (el) { el.dataset.bcCountInitialized = 'true'; });

    if (!('IntersectionObserver' in window) || !motionOK()) {
      targets.forEach(function (el) {
        el.textContent = (el.dataset.countPrefix || '') + el.dataset.countTo + (el.dataset.countSuffix || '');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        observer.unobserve(el);

        var target = parseFloat(el.dataset.countTo) || 0;
        var prefix = el.dataset.countPrefix || '';
        var suffix = el.dataset.countSuffix || '';
        var duration = parseInt(el.dataset.countDuration, 10) || 1400;
        var start = null;

        var step = function (timestamp) {
          if (start === null) start = timestamp;
          var progress = Math.min(1, (timestamp - start) / duration);
          // Ease-out cubic so the number settles instead of stopping dead.
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = prefix + Math.round(target * eased) + suffix;
          if (progress < 1) window.requestAnimationFrame(step);
        };
        window.requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });

    targets.forEach(function (el) {
      el.textContent = (el.dataset.countPrefix || '') + '0' + (el.dataset.countSuffix || '');
      observer.observe(el);
    });
  };

  // ----- Cross-page view transitions -----
  // On the way out, tag the photograph of the product being opened so
  // the browser can morph it into the product page's main image.
  var PRODUCT_LINK_SELECTOR = '.bc a.product-card[href], .bc .product-card-link[href]';
  var viewTransitionsBound = false;

  var productHandle = function (href) {
    try {
      var path = new URL(href, window.location.href).pathname;
      var parts = path.split('/products/');
      return parts.length > 1 ? parts[1].split('/')[0] : null;
    } catch (error) {
      return null;
    }
  };

  var clearTransitionNames = function () {
    document.querySelectorAll('[data-bc-vt-tagged]').forEach(function (node) {
      node.style.removeProperty('view-transition-name');
      delete node.dataset.bcVtTagged;
    });
  };

  var initViewTransitions = function () {
    if (viewTransitionsBound) return;
    if (!('startViewTransition' in document) || !('onpageswap' in window)) return;
    viewTransitionsBound = true;

    window.addEventListener('pageswap', function (event) {
      if (!event.viewTransition || !event.activation || !event.activation.entry) return;
      var handle = productHandle(event.activation.entry.url);
      if (!handle) return;

      var match = null;
      document.querySelectorAll(PRODUCT_LINK_SELECTOR).forEach(function (link) {
        if (!match && productHandle(link.getAttribute('href')) === handle) match = link;
      });
      if (!match) return;

      var image = match.querySelector('img:not(.hover-img)') || match.querySelector('img');
      if (!image) return;
      image.style.setProperty('view-transition-name', 'bc-product-media');
      image.dataset.bcVtTagged = 'true';
    });

    window.addEventListener('pagereveal', clearTransitionNames);
    window.addEventListener('pageshow', clearTransitionNames);
  };

  var init = function (root) {
    root = root || document;

    // ----- Accordions (.bc .accordion) -----
    nodes(root, '.bc .accordion .item').forEach(function (item) {
      if (item.dataset.bcAccordionInitialized === 'true') return;

      var head = item.querySelector('.head');
      var body = item.querySelector('.body');
      if (!head || !body) return;

      item.dataset.bcAccordionInitialized = 'true';
      var isOpen = item.classList.contains('open');
      head.setAttribute('aria-expanded', String(isOpen));
      if (body.id) head.setAttribute('aria-controls', body.id);
      body.hidden = !isOpen;
      body.style.display = isOpen ? 'block' : 'none';

      head.addEventListener('click', function () {
        isOpen = item.classList.toggle('open');
        head.setAttribute('aria-expanded', String(isOpen));
        body.hidden = !isOpen;
        body.style.display = isOpen ? 'block' : 'none';
        var indicator = head.querySelector('.indicator');
        if (indicator) indicator.textContent = isOpen ? '−' : '+';
      });
    });

    // ----- Tab groups (shopping paths, delivery tabs) -----
    nodes(root, '.bc [data-tabs]').forEach(function (group) {
      var updatePanels = function (btn) {
        var target = btn.dataset.tabTarget;
        if (!target) return;
        var scope = group.closest('[data-tabs-scope]') || group.parentElement || document;
        scope.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
          panel.hidden = panel.dataset.tabPanel !== target;
          panel.style.display = panel.hidden ? 'none' : '';
        });
      };

      group.querySelectorAll('button').forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.classList.contains('active') ? 'true' : 'false');
        if (btn.dataset.bcTabInitialized === 'true') return;
        btn.dataset.bcTabInitialized = 'true';

        btn.addEventListener('click', function (e) {
          if (btn.type !== 'submit') e.preventDefault();
          group.querySelectorAll('button').forEach(function (button) {
            var active = button === btn;
            button.classList.toggle('active', active);
            button.setAttribute('aria-pressed', active ? 'true' : 'false');
          });

          var status = group.parentElement && group.parentElement.querySelector('[data-tab-status]');
          if (status) status.textContent = 'Shop for: ' + btn.textContent.trim();
          var dots = group.parentElement && group.parentElement.querySelectorAll('.dots .dot');
          if (dots) dots.forEach(function (dot, index) {
            dot.classList.toggle('active', index === Array.prototype.indexOf.call(group.querySelectorAll('button'), btn));
          });

          updatePanels(btn);
        });
      });

      var activeButton = group.querySelector('button.active') || group.querySelector('button');
      if (activeButton) updatePanels(activeButton);
    });

    // ----- Contact shortcuts -----
    nodes(root, '.bc [data-contact-topic]').forEach(function (link) {
      if (link.dataset.bcContactTopicInitialized === 'true') return;
      link.dataset.bcContactTopicInitialized = 'true';

      link.addEventListener('click', function () {
        var page = link.closest('.bc-contact-page') || document;
        var topic = page.querySelector('#ContactTopic');
        if (topic && link.dataset.contactTopic) topic.value = link.dataset.contactTopic;
      });
    });

    // ----- Postal-code checker -----
    nodes(root, '.bc [data-postal-check]').forEach(function (form) {
      if (form.dataset.bcPostalInitialized === 'true') return;
      form.dataset.bcPostalInitialized = 'true';

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('input');
        var value = ((input && input.value) || '').replace(/\s/g, '').toUpperCase();
        var result = form.parentElement.querySelector('[data-postal-result]');
        if (!result || value.length < 3) return;

        var prefix = value.slice(0, 3);
        var matched = null;
        document.querySelectorAll('[data-zone-prefixes]').forEach(function (zone) {
          var prefixes = zone.dataset.zonePrefixes.toUpperCase().split(',').map(function (p) { return p.trim(); });
          if (!matched && prefixes.some(function (p) { return p && prefix.indexOf(p) === 0; })) matched = zone;
        });

        result.classList.toggle('outside', !matched);
        result.textContent = matched
          ? result.dataset.msgIn + ' ' + ((matched.querySelector('.name') || {}).textContent || '') + ' — ' + ((matched.querySelector('.fee') || {}).textContent || '')
          : result.dataset.msgOut;

        setActiveZone(matched ? matched.dataset.zoneId : null);
      });
    });

    // ----- Zone map ↔ zone list highlighting -----
    nodes(root, '.bc [data-zone-list]').forEach(function (list) {
      if (list.dataset.bcZonesInitialized === 'true') return;
      list.dataset.bcZonesInitialized = 'true';

      list.querySelectorAll('.zone[data-zone-id]').forEach(function (zone) {
        var setHover = function (on) { hoverZone(zone.dataset.zoneId, on); };
        zone.addEventListener('mouseenter', function () { setHover(true); });
        zone.addEventListener('mouseleave', function () { setHover(false); });
        zone.addEventListener('focusin', function () { setHover(true); });
        zone.addEventListener('focusout', function () { setHover(false); });
      });

      document.querySelectorAll('[data-zone-map] .zone-shape').forEach(function (shape) {
        shape.addEventListener('mouseenter', function () { hoverZone(shape.dataset.zoneId, true); });
        shape.addEventListener('mouseleave', function () { hoverZone(shape.dataset.zoneId, false); });
      });
    });

    // ----- Global header: mobile navigation and search -----
    nodes(root, '.bc[data-bc-header-root]').forEach(function (headerRoot) {
      if (headerRoot.dataset.bcHeaderInitialized === 'true') return;
      headerRoot.dataset.bcHeaderInitialized = 'true';

      var nav = headerRoot.querySelector('.primary-nav');
      var menuToggle = headerRoot.querySelector('[data-menu-toggle]');
      var searchToggle = headerRoot.querySelector('[data-header-search-toggle]');
      var searchPanel = headerRoot.querySelector('[data-header-search]');

      var closeMenu = function () {
        if (!nav || !menuToggle) return;
        nav.classList.remove('open');
        menuToggle.setAttribute('aria-expanded', 'false');
        menuToggle.setAttribute('aria-label', 'Open menu');
        document.documentElement.classList.remove('bc-menu-open');
      };
      var closeSearch = function () {
        if (!searchPanel || !searchToggle) return;
        searchPanel.classList.remove('open');
        searchToggle.setAttribute('aria-expanded', 'false');
      };

      if (menuToggle && nav) menuToggle.addEventListener('click', function () {
        var opening = !nav.classList.contains('open');
        closeSearch();
        nav.classList.toggle('open', opening);
        menuToggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
        menuToggle.setAttribute('aria-label', opening ? 'Close menu' : 'Open menu');
        document.documentElement.classList.toggle('bc-menu-open', opening);
      });

      if (searchToggle && searchPanel) searchToggle.addEventListener('click', function (event) {
        event.preventDefault();
        var opening = !searchPanel.classList.contains('open');
        closeMenu();
        searchPanel.classList.toggle('open', opening);
        searchToggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
        if (opening) {
          var input = searchPanel.querySelector('input[type="search"]');
          if (input) window.setTimeout(function () { input.focus(); }, 0);
        }
      });

      headerRoot.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        closeMenu();
        closeSearch();
        headerRoot.querySelectorAll('.nav-dropdown[open]').forEach(function (dropdown) {
          dropdown.removeAttribute('open');
        });
      });

      if (nav) nav.addEventListener('click', function (event) {
        if (event.target.closest('a')) closeMenu();
      });

      headerRoot.addEventListener('click', function (event) {
        if (!event.target.closest('[data-cart-drawer-open]')) return;
        closeMenu();
        closeSearch();
      });

      var desktopHeader = window.matchMedia('(min-width: 901px)');
      var resetMobileHeader = function (event) {
        if (!event.matches) return;
        closeMenu();
        closeSearch();
        headerRoot.querySelectorAll('.nav-dropdown[open]').forEach(function (dropdown) {
          dropdown.removeAttribute('open');
        });
      };
      if (desktopHeader.addEventListener) desktopHeader.addEventListener('change', resetMobileHeader);
      else if (desktopHeader.addListener) desktopHeader.addListener(resetMobileHeader);

      document.addEventListener('click', function (event) {
        if (headerRoot.contains(event.target)) return;
        closeMenu();
        closeSearch();
        headerRoot.querySelectorAll('.nav-dropdown[open]').forEach(function (dropdown) {
          dropdown.removeAttribute('open');
        });
      });
    });

    // ----- Homepage quick add -----
    nodes(root, '.bc .bc-quick-add').forEach(function (form) {
      if (form.dataset.bcQuickAddInitialized === 'true') return;
      form.dataset.bcQuickAddInitialized = 'true';

      form.addEventListener('submit', function (event) {
        if (!window.fetch || form.dataset.bcSubmitting === 'true') return;
        event.preventDefault();

        var button = form.querySelector('[data-quick-add]');
        var label = form.querySelector('[data-quick-add-text]');
        var originalLabel = label ? label.textContent : 'Quick add';
        var cartRoot = rootUrl();
        form.dataset.bcSubmitting = 'true';
        if (button) button.disabled = true;
        if (label) label.textContent = 'Adding…';

        fetch(cartRoot + 'cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' }
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Quick add failed');
            return fetch(cartRoot + 'cart.js');
          })
          .then(function (response) { return response.ok ? response.json() : null; })
          .then(function (cart) {
            var pill = document.querySelector('.bc .cart-pill');
            if (cart) setCartCount(cart.item_count);
            if (pill) {
              flyToCart(button, pill);
              pill.classList.remove('bc-pulse');
              void pill.offsetWidth;
              pill.classList.add('bc-pulse');
            }
            if (button) button.classList.add('bc-added');
            if (label) label.textContent = 'Added ✓';
            document.dispatchEvent(new CustomEvent('bc:cart:added', { detail: cart }));
            window.setTimeout(function () {
              if (button) {
                button.disabled = false;
                button.classList.remove('bc-added');
              }
              if (label) label.textContent = originalLabel;
            }, 1500);
          })
          .catch(function () { form.submit(); })
          .finally(function () { form.dataset.bcSubmitting = 'false'; });
      });
    });

    // ----- Product media, variants and quantity -----
    nodes(root, '.bc[data-bc-product-root]').forEach(function (productRoot) {
      if (productRoot.dataset.bcProductInitialized === 'true') return;
      productRoot.dataset.bcProductInitialized = 'true';

      var gallery = productRoot.querySelector('[data-product-gallery]');
      // Stacked galleries show every image at once and the thumb rail
      // becomes a jump list; the switcher keeps one panel visible.
      var stacked = gallery && gallery.dataset.galleryLayout === 'stacked';

      var markActiveThumb = function (targetId) {
        if (!gallery) return;
        gallery.querySelectorAll('[data-media-target]').forEach(function (button) {
          var active = button.dataset.mediaTarget === targetId;
          button.classList.toggle('active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      };

      var activateMedia = function (targetId, scroll) {
        if (!gallery || !targetId) return;
        if (stacked) {
          // Only an explicit thumb click scrolls; a variant change just
          // moves the highlight so the page does not jump underfoot.
          var panel = scroll ? document.getElementById(targetId) : null;
          if (panel) panel.scrollIntoView({ behavior: motionOK() ? 'smooth' : 'auto', block: 'center' });
        } else {
          gallery.querySelectorAll('.media-panel').forEach(function (panel) {
            panel.hidden = panel.id !== targetId;
          });
        }
        markActiveThumb(targetId);
      };

      if (gallery) {
        gallery.querySelectorAll('[data-media-target]').forEach(function (button) {
          button.addEventListener('click', function () { activateMedia(button.dataset.mediaTarget, true); });
        });
      }

      // In stacked mode the thumb rail tracks whichever panel is centred.
      if (gallery && stacked && 'IntersectionObserver' in window) {
        var panelObserver = new IntersectionObserver(function (entries) {
          var best = null;
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            if (!best || entry.intersectionRatio > best.intersectionRatio) best = entry;
          });
          if (best) markActiveThumb(best.target.id);
        }, { rootMargin: '-45% 0px -45% 0px', threshold: [0, 0.25, 0.5] });
        gallery.querySelectorAll('.media-panel').forEach(function (panel) {
          panelObserver.observe(panel);
        });
      }

      var form = productRoot.querySelector('.bc-product-form');
      var variantsNode = productRoot.querySelector('[data-product-variants]');
      var variants = [];
      if (variantsNode) {
        try { variants = JSON.parse(variantsNode.textContent); } catch (error) { variants = []; }
      }

      var setVariant = function () {
        if (!form || !variants.length) return;
        var selectedOptions = [];
        form.querySelectorAll('[data-product-option]:checked').forEach(function (input) {
          selectedOptions[Number(input.dataset.optionPosition) - 1] = input.value;
        });

        var variant = variants.find(function (candidate) {
          return candidate.options.every(function (option, index) { return option === selectedOptions[index]; });
        });
        var idInput = form.querySelector('[data-variant-id]');
        var addButton = form.querySelector('[data-add-to-cart]');
        var addText = form.querySelector('[data-add-to-cart-text]');
        var price = productRoot.querySelector('[data-product-price]');
        var comparePrice = productRoot.querySelector('[data-compare-price]');

        form.querySelectorAll('[data-product-option]').forEach(function (input) {
          var label = form.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('active', input.checked);
        });

        if (!variant) {
          if (idInput) idInput.value = '';
          if (addButton) addButton.disabled = true;
          if (addText && addButton) addText.textContent = addButton.dataset.unavailableLabel;
          return;
        }

        if (idInput) idInput.value = variant.id;
        if (price) price.textContent = formatMoney(variant.price);
        if (comparePrice) {
          var onSale = Number(variant.compare_at_price) > Number(variant.price);
          comparePrice.hidden = !onSale;
          comparePrice.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
        }
        if (addButton) addButton.disabled = !variant.available;
        if (addText && addButton) {
          addText.textContent = variant.available
            ? addButton.dataset.addLabel + ' · ' + formatMoney(variant.price)
            : addButton.dataset.soldLabel;
        }

        var mediaId = variant.featured_media && variant.featured_media.id;
        if (!mediaId && variant.featured_image) mediaId = variant.featured_image.id;
        if (mediaId && gallery) {
          var panel = gallery.querySelector('[data-media-id="' + mediaId + '"]');
          if (panel) activateMedia(panel.id);
        }

        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      };

      if (form) {
        form.querySelectorAll('[data-product-option]').forEach(function (input) {
          input.addEventListener('change', setVariant);
        });

        var quantity = form.querySelector('[data-quantity-input]');
        var minus = form.querySelector('[data-quantity-minus]');
        var plus = form.querySelector('[data-quantity-plus]');
        if (minus && quantity) minus.addEventListener('click', function () {
          quantity.value = Math.max(1, (parseInt(quantity.value, 10) || 1) - 1);
        });
        if (plus && quantity) plus.addEventListener('click', function () {
          quantity.value = Math.max(1, (parseInt(quantity.value, 10) || 1) + 1);
        });
        if (quantity) quantity.addEventListener('change', function () {
          quantity.value = Math.max(1, parseInt(quantity.value, 10) || 1);
        });

        // AJAX add-to-cart with fly-to-cart animation; falls back to a
        // normal form submit if the fetch fails for any reason.
        form.addEventListener('submit', function (event) {
          if (!window.fetch || form.dataset.bcSubmitting === 'true') return;
          var addButton = form.querySelector('[data-add-to-cart]');
          if (addButton && addButton.disabled) return;
          event.preventDefault();
          form.dataset.bcSubmitting = 'true';

          var cartRoot = rootUrl();
          fetch(cartRoot + 'cart/add.js', {
            method: 'POST',
            body: new FormData(form),
            headers: { Accept: 'application/json' }
          })
            .then(function (response) {
              if (!response.ok) throw new Error('Add to cart failed');
              return fetch(cartRoot + 'cart.js');
            })
            .then(function (response) { return response.ok ? response.json() : null; })
            .then(function (cart) {
              form.dataset.bcSubmitting = 'false';
              var pill = document.querySelector('.bc .cart-pill');
              if (cart) setCartCount(cart.item_count);
              if (pill) {
                flyToCart(addButton, pill);
                pill.classList.remove('bc-pulse');
                void pill.offsetWidth;
                pill.classList.add('bc-pulse');
              }
              var addText = form.querySelector('[data-add-to-cart-text]');
              if (addButton && addText) {
                var originalText = addText.textContent;
                addButton.classList.add('bc-added');
                addText.textContent = 'Added ✓';
                window.setTimeout(function () {
                  addButton.classList.remove('bc-added');
                  addText.textContent = originalText;
                }, 1600);
              }
              document.dispatchEvent(new CustomEvent('bc:cart:added', { detail: cart }));
            })
            .catch(function () {
              form.dataset.bcSubmitting = 'false';
              form.submit();
            });
        });
      }
    });

    // ----- Collection filters and sorting -----
    nodes(root, '.bc[data-bc-collection-root]').forEach(function (collectionRoot) {
      if (collectionRoot.dataset.bcCollectionInitialized === 'true') return;
      collectionRoot.dataset.bcCollectionInitialized = 'true';

      // Filtering and sorting reload the page; show that something is
      // happening rather than leaving the old grid looking interactive.
      var main = collectionRoot.querySelector('[data-collection-main]');
      var startLoading = function () {
        if (main) main.classList.add('is-loading');
      };
      window.addEventListener('pageshow', function (event) {
        if (event.persisted && main) main.classList.remove('is-loading');
      });

      var filterForm = collectionRoot.querySelector('[data-collection-filters]');
      if (filterForm) {
        filterForm.querySelectorAll('[data-filter-input]').forEach(function (input) {
          input.addEventListener('change', function () {
            startLoading();
            filterForm.submit();
          });
        });
        filterForm.addEventListener('submit', startLoading);
      }

      collectionRoot.querySelectorAll('.active-filter, .clear-filters').forEach(function (link) {
        link.addEventListener('click', startLoading);
      });

      var sort = collectionRoot.querySelector('[data-collection-sort]');
      if (sort) sort.addEventListener('change', function () {
        startLoading();
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });

      // Rail popovers behave like the header dropdowns: one at a time,
      // dismissed by Escape or a click outside.
      var railGroups = collectionRoot.querySelectorAll('[data-filter-layout="rail"] .filter-group');
      if (railGroups.length) {
        railGroups.forEach(function (group) {
          group.addEventListener('toggle', function () {
            if (!group.open) return;
            railGroups.forEach(function (other) {
              if (other !== group) other.removeAttribute('open');
            });
          });
        });
        document.addEventListener('click', function (event) {
          railGroups.forEach(function (group) {
            if (group.open && !group.contains(event.target)) group.removeAttribute('open');
          });
        });
        collectionRoot.addEventListener('keydown', function (event) {
          if (event.key !== 'Escape') return;
          railGroups.forEach(function (group) { group.removeAttribute('open'); });
        });
      }

      var drawer = collectionRoot.querySelector('[data-filter-drawer]');
      if (drawer && window.matchMedia('(max-width: 768px)').matches) drawer.removeAttribute('open');
    });

    // ----- Cart drawer (mounted before triggers so the pill can open it) -----
    initCartDrawer(root);
    initCartDrawerTriggers(root);
    initViewTransitions();
    initSplash(root);
    initCountUp(root);
    initCarousels(root);

    // ----- Scroll reveals (after sections above render) -----
    initReveal(root);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  // Dawn re-renders sections in the theme editor without a full page reload.
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
